import omit from 'ramda/src/omit'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { CREATE_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import wait from 'root/src/shared/util/wait'
import mixpanel from 'root/src/client/logic/analytics/mixpanel'
import { mixpanelEvents } from 'root/src/shared/constants/mixpanel'

export default formData => async (dispatch) => {
	const payload = omit(['mnemonicId'], formData)
	const { error, body } = await dispatch(apiRequest(CREATE_PROJECT, payload))

	mixpanel.track(mixpanelEvents.projectCreated)
	// this wait is here because projects aren't instantly created/pledged with elasticSearch
	await wait(1000)
	return { error,	body }
}
